// extracted by mini-css-extract-plugin
export default {"Container":"event_Container__BGnB+","begin":"event_begin__74UON","CardContainer":"event_CardContainer__msBkP"};